export default "__VITE_ASSET__97a5a25e__"